/*
  OTCD Substack-style article template — share buttons + newsletter polish.

  No dependencies. Loaded with defer.

  The LinkedIn and email share links are real hrefs rendered in Liquid, so
  they work with JavaScript disabled. This file only:
    - opens LinkedIn in a sized popup instead of a new tab,
    - implements copy-to-clipboard, which has no no-JS equivalent,
    - upgrades newsletter validation messaging (browser validation is the
      fallback: novalidate is only set once this script is running),
    - publishes the sticky header's height as --otcd-header-offset so the
      sticky sidebar sits below it rather than under it.
*/
(function () {
  'use strict';

  var COPY_RESET_MS = 4000;

  function initShare(root) {
    var status = root.querySelector('[data-share-status]');
    var copyBtn = root.querySelector('[data-share="copy"]');
    var linkedinLink = root.querySelector('[data-share="linkedin"]');
    var resetTimer = null;

    function say(message) {
      if (!status) return;
      status.textContent = message;
      if (resetTimer) clearTimeout(resetTimer);
      if (message) {
        resetTimer = setTimeout(function () {
          status.textContent = '';
        }, COPY_RESET_MS);
      }
    }

    if (linkedinLink) {
      linkedinLink.addEventListener('click', function (event) {
        // Let modified clicks (new tab, save, middle-click) behave normally.
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        var win = window.open(
          linkedinLink.href,
          'otcd-share-linkedin',
          'width=680,height=620,noopener,noreferrer'
        );
        // If the popup was blocked, fall through to the normal navigation.
        if (win) event.preventDefault();
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url = copyBtn.getAttribute('data-share-url') || window.location.href;

        copyText(url).then(
          function () {
            say(copyBtn.getAttribute('data-copied-label') || 'Link copied');
          },
          function () {
            say(copyBtn.getAttribute('data-failed-label') || 'Press Ctrl+C to copy');
            selectFallback(url);
          }
        );
      });
    }
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var area = document.createElement('textarea');
        area.value = text;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.top = '-1000px';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(area);
        ok ? resolve() : reject(new Error('copy rejected'));
      } catch (error) {
        reject(error);
      }
    });
  }

  /* Last resort: put the URL somewhere the visitor can copy it by hand. */
  function selectFallback(url) {
    if (window.prompt) window.prompt('Copy this link:', url);
  }

  function initNewsletter(form) {
    var input = form.querySelector('input[type="email"]');
    var message = form.querySelector('[data-newsletter-message]');
    if (!input || !message) return;

    // Only now that JS is confirmed running do we take over from the browser.
    form.setAttribute('novalidate', 'novalidate');

    form.addEventListener('submit', function (event) {
      if (input.value.trim() === '') {
        block(event, form.getAttribute('data-error-empty') || 'Enter your work email.');
        return;
      }
      if (!input.checkValidity()) {
        block(event, form.getAttribute('data-error-invalid') || 'Enter a valid email address.');
        return;
      }
      clear();
    });

    input.addEventListener('input', clear);

    function block(event, text) {
      event.preventDefault();
      message.textContent = text;
      message.classList.add('is-error');
      message.classList.remove('is-ok');
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    }

    function clear() {
      // Never wipe a server-rendered success or error message.
      if (message.hasAttribute('data-server-message')) return;
      message.textContent = '';
      message.classList.remove('is-error');
      input.removeAttribute('aria-invalid');
    }
  }

  // The theme header is sticky, so the sidebar has to clear it. Its height
  // changes with the announcement bar and breakpoints, hence the observer.
  // A sidebar too tall to fit below the header would have its bottom stuck
  // off-screen, so stickiness is dropped (.is-unstuck) in that case.
  function trackHeaderOffset() {
    var header = document.querySelector('.shopify-section-header');
    var sidebar = document.querySelector('.otcd-article-page .sidebar-sticky');
    if (!header || !window.ResizeObserver) return;
    var root = document.documentElement;
    var GAP = 48; // 24px above and below the sidebar

    function update() {
      var offset = header.getBoundingClientRect().height;
      root.style.setProperty('--otcd-header-offset', offset + 'px');
      if (sidebar) {
        var fits = sidebar.offsetHeight + offset + GAP <= window.innerHeight;
        sidebar.classList.toggle('is-unstuck', !fits);
      }
    }

    var observer = new ResizeObserver(update);
    observer.observe(header);
    if (sidebar) observer.observe(sidebar);
    window.addEventListener('resize', update);
  }

  function init() {
    trackHeaderOffset();

    var shares = document.querySelectorAll('[data-otcd-share]');
    for (var i = 0; i < shares.length; i++) initShare(shares[i]);

    var forms = document.querySelectorAll('[data-otcd-newsletter]');
    for (var j = 0; j < forms.length; j++) initNewsletter(forms[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
